<button
  type="button"
  class="app-button"
  [class.primary]="variant() === 'primary'"
  [class.secondary]="variant() === 'secondary'"
  [class.yellow]="variant() === 'yellow'"
  [class.learn-more]="variant() === 'learn-more'"
  [class.danger]="variant() === 'danger'"
  [disabled]="disabled()"
  (click)="onClick()">
  @if (iconName()) {
    <app-icon [name]="iconName()!" [size]="16" />
  } @else if (icon()) {
    <img [src]="icon()" alt="" class="app-button__icon" />
  }
  <p>{{ label() }}</p>
</button>
